/**
 * @deprecated All customers are now on a multi-SKU experience. Branches for !supportsMultipleSku() are dead code.
 */
export function supportsMultipleSku(account?: { pricingTableId: string }): boolean {
  return account?.pricingTableId === '8' ?? false;
}
